import React, { FC } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Breadcrumbs, Heading } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import styled from '../../styled';
import { useBuildingData } from '../../hooks/useBuildingDetails/buildingDetailsHooks';
import { BuildingCard } from '../registrationV2025/pages/omBoligen/buildingCard';
import {
  BreadcrumbsWrapper,
  MainContentWrapper,
  PageLayout,
  VerticalContainer
} from '../registrationV2025/components/styledComponents';
import { PageLoader } from '../registrationV2025/components/pageLoader';
import { BuildingPageWrapper } from '../building/buildingPageLayout';

import { TiltakCard } from './components/tiltak';
import { Sluttilstand } from './components/sluttilstand';
import { Fortilstand } from './components/fortilstand';
import { useEnergiplanRegistrations } from './hooks/useEnergiplanRegistrations';
import { DeleteEnergiplanButton } from './components/deleteEnergiplanButton';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

const Energiplan: FC = () => {
  const { buildingId } = useParams();
  const { building, buildingLoading } = useBuildingData(buildingId);
  const { energiplanRegistrationsLoading, energyAnalysisSteg1 } = useEnergiplanRegistrations(building?.gyldigSoknad);
  const { t } = useTranslation();
  const gyldigSoknad = building?.gyldigSoknad;

  if (buildingLoading || energiplanRegistrationsLoading) {
    return <PageLoader />;
  }

  return (
    <BuildingPageWrapper>
      <PageLayout>
        <BreadcrumbsWrapper>
          <Breadcrumbs>
            <Breadcrumbs.Link asChild aria-label={t('registrering.back')}>
              <Link to={`../bygg/${buildingId}/energiplan`}>{t('screens.energiplan.index.backLink')}</Link>
            </Breadcrumbs.Link>
          </Breadcrumbs>
        </BreadcrumbsWrapper>
        <MainContentWrapper>
          <VerticalContainer>
            <Heading level={1} data-size="lg">
              {t('buildingScreen.tab.energiplan.tabTitle')}
            </Heading>
            <BuildingCard building={building} />

            <Content>
              <Heading data-size="md">{t('screens.energiplan.index.beforeTiltakHeading')}</Heading>
              <Fortilstand energyAnalysis={energyAnalysisSteg1} />

              <Heading data-size="md">{t('screens.energiplan.index.tiltakHeading')}</Heading>
              <TiltakCard soknad={gyldigSoknad} />

              <Heading data-size="md">{t('screens.energiplan.index.afterTiltakHeading')}</Heading>
              <Sluttilstand soknad={gyldigSoknad} />
            </Content>

            <DeleteEnergiplanButton soknadId={gyldigSoknad?.soknadId} buildingId={buildingId} />
          </VerticalContainer>
        </MainContentWrapper>
      </PageLayout>
    </BuildingPageWrapper>
  );
};

export default Energiplan;
